import { render, staticRenderFns } from "./StatsTeamHealth.vue?vue&type=template&id=47f564e7&scoped=true&lang=html&"
import script from "./StatsTeamHealth.vue?vue&type=script&lang=js&"
export * from "./StatsTeamHealth.vue?vue&type=script&lang=js&"
import style0 from "./StatsTeamHealth.vue?vue&type=style&index=0&id=47f564e7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f564e7",
  null
  
)

export default component.exports